//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: ['index', 'event'],
  methods: {
  }
}
